<div class="products-container-component-root">
  <div class="title">
    {{ labels.productList }}
    <div class="select-container">
      <span>{{ labels.selectPlaceholder }}</span>
      <app-multi-select [options]="availableFamily"
                        [initialData]="availableFamily[0]"
                        (valueChange)="changeFamily($event)"
      ></app-multi-select>
    </div>
  </div>
  <app-product-list [familyId]="selectedFamily"></app-product-list>
  <div class="footer-button">
    <app-icon-button v2 icon="add_circle_outline" (clickAction)="goToProductEdit()"> {{labels.addParticipatingProduct}} </app-icon-button>
  </div>
</div>
